var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFace = function SvgFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.625C24.465 29.625 23.625 30.465 23.625 31.5C23.625 32.535 24.465 33.375 25.5 33.375C26.535 33.375 27.375 32.535 27.375 31.5C27.375 30.465 26.535 29.625 25.5 29.625ZM34.5 29.625C33.465 29.625 32.625 30.465 32.625 31.5C32.625 32.535 33.465 33.375 34.5 33.375C35.535 33.375 36.375 32.535 36.375 31.5C36.375 30.465 35.535 29.625 34.5 29.625ZM30 15C21.72 15 15 21.72 15 30C15 38.28 21.72 45 30 45C38.28 45 45 38.28 45 30C45 21.72 38.28 15 30 15ZM30 42C23.385 42 18 36.615 18 30C18 29.565 18.03 29.13 18.075 28.71C21.615 27.135 24.42 24.24 25.89 20.655C28.605 24.495 33.075 27 38.13 27C39.3 27 40.425 26.865 41.505 26.61C41.82 27.675 42 28.815 42 30C42 36.615 36.615 42 30 42Z",
    fill: "#2D3336"
  })));
};
export default SvgFace;